import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Holidays/Add";
import { TableData } from "@/App/Holidays/Table";
import { getHolidaysData } from "@/Api/holidays";
import { HolidayProps } from "@/types/holiday";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { UnityFilter, useUnityFilter } from "@/components/UnityFilter";
import { PageHeader } from "@/components/PageHeader";
import { CalendarDays } from "lucide-react";

export type TableDataProps = HolidayProps;

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  const filter = useUnityFilter({ withUnity: false });

  useEffect(() => {
    (async () => {
      setState("loading");
      const { data } = await getHolidaysData(1, filter.nameParam);
      setListData(data?.response);
      setState("production");
    })();
  }, [filter.nameParam]);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getHolidaysData(listData?.current_page + 1, filter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getHolidaysData(listData?.current_page - 1, filter.nameParam);
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getHolidaysData(listData?.last_page, filter.nameParam);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-holidays-list")}>
        <PageHeader
          icon={CalendarDays}
          title="Feriados"
          description="Cadastre os feriados considerados no ponto"
        >
          <If condition={hasPermission("create-holiday")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <UnityFilter filter={filter} namePlaceholder="Buscar por nome" hideUnity />
          {state === "loading" ? (
            <CreateLoaderTable cols={5} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
